import { api } from 'shared/api'

import { usersApiSchemas } from './schemas'

export const UsersApi = {
  // User data & roles
  fetch: api.account.createGet({
    url: '/users/list',
    schemas: usersApiSchemas.fetch,
  }),
  update: api.account.createPost({
    url: '/users/updateRole',
    schemas: usersApiSchemas.update,
  }),
  remove: api.account.createPost({
    url: '/users/remove',
    schemas: usersApiSchemas.remove,
  }),
  setBillingAccess: api.account.createPost({
    url: '/users/setBillingAccess',
    schemas: usersApiSchemas.setBillingAccess,
  }),
  setInboxUser: api.account.createPost({
    url: '/users/setInboxUser',
    schemas: usersApiSchemas.setInboxUser,
  }),
  accessRequestFetch: api.account.createGet({
    url: '/requestAccess/getPending',
    schemas: usersApiSchemas.accessRequestFetch,
  }),
  accessRequestApprove: api.account.createPost({
    url: '/requestAccess/approve',
    schemas: usersApiSchemas.accessRequestApprove,
  }),
  accessRequestDecline: api.account.createPost({
    url: '/requestAccess/decline',
    schemas: usersApiSchemas.accessRequestDecline,
  }),
  setConversationsLimit: api.account.createPost({
    url: '/users/setThreadsLimit',
    schemas: usersApiSchemas.setConversationsLimit,
  }),
  setAutoAssignmentEnabled: api.account.createPost({
    url: '/users/setAutoAssignEnabled',
    schemas: usersApiSchemas.setAutoAssignEnabled,
  }),
  generateInviteLink: api.account.createPost({
    url: '/users/generateInviteLink',
    schemas: usersApiSchemas.generateInviteLink,
  }),
}
